import {SELECT_TYPE, TYPE_ALL} from './FileTypeResource';

export const objectTypeOptionResource = [
    {
        name: SELECT_TYPE, value: TYPE_ALL
    },
    {
        name: 'FOLDER', value: 'folder'
    },
    {
        name: 'FILE', value: 'file'
    }
];
